require([
    "common/formatter",
    "common/spinner",
    "common/alertMessage",
    "productOptions/productOptions"
],
    function (formatter, spinner, alertMessage, productOptions) {

    const totalsSpinnerSelector = ".sample-classroom-products .totals .spinner-wrapper";

    function initClickHandlers() {
        $(".sample-classroom-products").off("priceTotalChanged").on("priceTotalChanged", calculateTotals);
        $(".sample-classroom-products button.add-all-to-cart").off("click").on("click", addAllToCartClicked);
    }

    function calculateTotals(event) {
        var eventTarget = this;
        spinner.show(totalsSpinnerSelector);
        var itemCount = 0;
        var subtotal = 0;
        $(eventTarget).find(".product-options").each(function (index, product) {
            var quantity = $(product).find(".quantity-selector input").val();
            itemCount += Number(quantity);
            var priceTotal = $(product).find(".price-total").data("priceTotal");
            subtotal += Number(priceTotal);
        });
        spinner.hide(totalsSpinnerSelector, function () {
            $(eventTarget).find(".item-count-value").text(itemCount);
            $(eventTarget).find(".subtotal-value").text(formatter.money(subtotal));
        });
    }

    function addAllToCartClicked(event) {
        var clickedElement = this;
        var message = $(clickedElement).closest(".sample-classroom-products").data("addAllToCartQuestion");
        alertMessage.yesNoQuestion(message, function () { addAllToCart(clickedElement); });
    }

    function addAllToCart(clickedElement) {
        var listSelector = ".sample-classroom-products";
        var spinnerSelector = listSelector + " .classroom-products-spinner-wrapper";

        productOptions.addAllToCart(listSelector, spinnerSelector);
    }


    initClickHandlers();
});
define("ClassroomProducts/main", function(){});

